import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Table, Thead, Tbody, Tr, Th, Td, TableContainer } from "@chakra-ui/react";
import { newMoney } from "~hooks/useHelpers";
import "./style.scss";
const RotaDoDiaVloz = ({ blocos, taticaLastCreatedAtDate }) => {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  const colors = ["positiva", "mix", "resgate", "premium"];

  useEffect(() => {
    const handleScroll = () => {
      const scrolly = globalThis.scrollY;
      const wHeight = globalThis.innerHeight;
      const dHeight = document.documentElement.scrollHeight;
      if (scrolly + wHeight >= dHeight - 1 && !loading && !visible) {
        setLoading(true);
        const timer = setTimeout(() => {
          setLoading(false);
          setVisible(true);
        }, 3000);

        return () => clearTimeout(timer);
      }
    };

    globalThis.addEventListener("scroll", handleScroll);
    return () => {
      globalThis.removeEventListener("scroll", handleScroll);
    };
  }, [loading, visible]);

  const datas = blocos?.VLOZ?.Gráfico?.datas || [];
  const dados = blocos?.VLOZ?.Gráfico?.dados || [];

  const datasOrdenadas = [...datas].sort((a, b) => {
    const [mA, yA] = a.split("/").map(Number);
    const [mB, yB] = b.split("/").map(Number);
    return yA === yB ? mA - mB : yA - yB;
  });

  const indiceOriginalPorData = datas.reduce((acc, data, index) => {
    acc[data] = index;
    return acc;
  }, {});

  const dadosOrdenados = dados.map((linha) => ({
    ...linha,
    dados: datasOrdenadas.map((data) => linha.dados[indiceOriginalPorData[data]]),
  }));

  return (
    <div className="containerForm container bg-white p-7 rounded-lg mt-[28px] relative">
      <div>
        <div className="px-3 py-4 text-center text-white rounded-t-lg bg-terciaria">
          <h2 className="text-xl font-bold">Super 4</h2>
        </div>
        <div className="container__vloz border-l border-r border-b border-[#4472C4] rounded-b-lg px-4 ">
          {(blocos.SUPER4 || []).map((bloco, index) => (
            <div key={`super4-${bloco.subBloco || index}`} className="content__vloz">
              <div className={"content__vloz--box content__vloz--box-" + colors[index]}>
                <h3 className="font-bold text-white">{bloco.subBloco}</h3>
              </div>
              <div className="w-full">
                {(bloco.dados || []).map((dado, indexDados) => (
                  <div key={`dado-${dado.indicador || indexDados}`} className="content__vloz--container">
                    <div className="content__vloz--title">
                      <p>{dado.indicador}</p>
                    </div>
                    <div className="content__vloz--desc">
                      <p>{dado.valor}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
      {taticaLastCreatedAtDate ? (
        <p className="flex justify-center mt-6">
          Atualizado em: <strong className="ml-2">{taticaLastCreatedAtDate}</strong>
        </p>
      ) : null}
      <div>
        <div className="bg-[#A6A6A6] text-white text-center rounded-t-lg px-3 py-4 mt-8">
          <h2 className="text-xl font-bold">VLOZ</h2>
        </div>
        <div className=" border-l border-r border-b border-[#4472C4] rounded-b-lg px-4 ">
          <div className="container__vloz ">
            <div className="content__vloz">
              <div className="content__vloz--box bg-[#A6A6A6]">
                <h3 className="font-bold text-white">INDICADORES</h3>
              </div>
              <div className="w-full">
                {(blocos?.VLOZ?.Tabela?.dados || []).map((subBloco, index) => (
                  <div key={`indicador-${subBloco.indicador || index}`} className="content__vloz--container">
                    <div className="content__vloz--title">
                      <p>{subBloco.indicador}</p>
                    </div>
                    <div className="content__vloz--desc">
                      <p>{subBloco.valor}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <TableContainer className="my-4 container__vloz--table">
            <Table variant="simple">
              <Thead className="container__vloz--table-head">
                <Tr>
                  <Th className="bg-[#E6E6E6] table-item sticky-col" borderRight="1px solid #FFFFFF">
                    Valores
                  </Th>
                  {datasOrdenadas.map((item, index) => (
                    <Th
                      className="bg-[#E6E6E6] table-item"
                      borderLeft="1px solid #E2E8F0"
                      borderRight="1px solid #FFFFFF"
                      key={`data-${item}`}
                    >
                      {item}
                    </Th>
                  ))}
                </Tr>
              </Thead>

              <Tbody>
                {dadosOrdenados
                  .slice()
                  .sort(
                    (a, b) => Number.parseInt(a.indicador.split(".")[0]) - Number.parseInt(b.indicador.split(".")[0])
                  )
                  .map((item, index) => (
                    <Tr
                      key={`row-${item.indicador || index}`}
                      style={{
                        backgroundColor: index >= dadosOrdenados.length - 2 ? "#e7f2d2" : "transparent",
                      }}
                    >
                      <Td
                        className="sticky-col"
                        borderLeft="1px solid #E2E8F0"
                        borderRight="1px solid #E2E8F0"
                        style={{
                          backgroundColor: index >= dadosOrdenados.length - 2 ? "#D8E5C0" : "",
                        }}
                      >
                        {item.indicador}
                      </Td>

                      {item.dados.map((dado, idx) => (
                        <Td
                          borderLeft="1px solid #E2E8F0"
                          borderRight="1px solid #E2E8F0"
                          key={`dado-${item.indicador}-${idx}`}
                        >
                          {dado.valor === "-" ? <p className="text-center">-</p> : newMoney(dado.valor)}
                        </Td>
                      ))}
                    </Tr>
                  ))}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
      {taticaLastCreatedAtDate ? (
        <p className="flex justify-center mt-8">
          Atualizado em: <strong className="ml-2">{taticaLastCreatedAtDate}</strong>
        </p>
      ) : null}
    </div>
  );
};

export default RotaDoDiaVloz;

RotaDoDiaVloz.propTypes = {
  blocos: PropTypes.shape({
    VLOZ: PropTypes.shape({
      Gráfico: PropTypes.shape({
        datas: PropTypes.arrayOf(PropTypes.string),
        dados: PropTypes.arrayOf(
          PropTypes.shape({
            indicador: PropTypes.string,
            dados: PropTypes.arrayOf(
              PropTypes.shape({
                valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
              })
            ),
          })
        ),
      }),
      Tabela: PropTypes.shape({
        dados: PropTypes.arrayOf(
          PropTypes.shape({
            indicador: PropTypes.string,
            valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          })
        ),
      }),
    }),
    SUPER4: PropTypes.arrayOf(
      PropTypes.shape({
        codigo: PropTypes.string,
        nome: PropTypes.string,
        dados: PropTypes.arrayOf(
          PropTypes.shape({
            valor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
          })
        ),
      })
    ),
  }).isRequired,
  taticaLastCreatedAtDate: PropTypes.string,
};
